import { Box, Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";
import { useSupportLinks } from "@src/appV2/support/hooks/useSupportLinks";

interface DisputeRejectedAlertProps {
  resolution: string;
}

export function DisputeRejectedAlert(props: DisputeRejectedAlertProps) {
  const { resolution } = props;

  const { placementInterviewAttendanceSimplifiedPolicySupportLink } = useSupportLinks();

  return (
    <Stack spacing={2}>
      <Text variant="body2" textAlign="center">
        <Box component="span" sx={{ fontWeight: 700 }}>
          Reason of rejection:
        </Box>{" "}
        {resolution}
      </Text>
      <Text variant="body2" textAlign="center">
        Click{" "}
        <a
          href={placementInterviewAttendanceSimplifiedPolicySupportLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          here
        </a>{" "}
        to review the interview attendance policy.
      </Text>
    </Stack>
  );
}
